'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var STATUS_UNAVAILABLE = exports.STATUS_UNAVAILABLE = 'unavailable';
var STATUS_AVAILABLE = exports.STATUS_AVAILABLE = 'available';
var STATUS_UNKNOWN = exports.STATUS_UNKNOWN = 'unknown';


//////////////////
// WEBPACK FOOTER
// ../node_modules/availability/dist/iterators/Status.js
// module id = 147
// module chunks = 0